module.exports = __webpack_public_path__ + "img/android.5fadce41.png";